import {
    FETCH_INITIAL_NOTES_DATA_REQUEST,
    FETCH_INITIAL_NOTES_DATA_SUCCESS,
    FETCH_INITIAL_NOTES_DATA_FAILURE,
  } from "./FetchInitialNotesDataTypes";
  
  const initialState = {
    loading: false,
    initialNotesData: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_INITIAL_NOTES_DATA_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_INITIAL_NOTES_DATA_SUCCESS:
        return {
          loading: false,
          initialNotesData: action.payload,
          error: "",
        };
      case FETCH_INITIAL_NOTES_DATA_FAILURE:
        return {
          loading: false,
          initialNotesData: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  